var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-withdrawal-success"},[_c('div',{staticClass:"modal-withdrawal-success__title"},[_vm._v(" Запрос на вывод средств успешно отправлен ")]),_c('div',{staticClass:"modal-withdrawal-success__subtitle"},[_vm._v(" Ожидайте поступление средств в течение суток ")])])
}]

export { render, staticRenderFns }